import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { IconButton, TableCell, TableRow } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { TableControls } from '../../../../BaseEditor';

function ChoicesRow({
  value, label, onChange, onDelete, canDelete, rowIndex, ctype,
}) {
  const onRowChange = useCallback(
    (e, p) => onChange(e, rowIndex, p),
    [onChange, rowIndex],
  );
  return (
    <TableRow
      key={value}
    >
      <TableCell>
        <TableControls.MultiVaueInput
          ctype={ctype}
          value={value}
          onChange={(e, v) => onRowChange(e, [v, label])}
        />
      </TableCell>
      <TableCell>
        <TableControls.StringInput
          value={label}
          onChange={(e, v) => onRowChange(e, [value, v])}
        />
      </TableCell>
      <TableCell>
        <IconButton
          disabled={!canDelete}
          onClick={(e) => onDelete(e, rowIndex)}
          color="error"
        >
          <FontAwesomeIcon icon={faTrash} size="xs" />
        </IconButton>

      </TableCell>
    </TableRow>
  );
}

ChoicesRow.propTypes = {
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]).isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  canDelete: PropTypes.bool.isRequired,
  rowIndex: PropTypes.number.isRequired,
  ctype: PropTypes.oneOf(['String', 'Date', 'Boolean', 'Integer', 'Decimal']).isRequired,
};

export default memo(ChoicesRow);
